module.exports = __webpack_public_path__ + "static/benefits3-dab22619d93afb1e30814fe5d3374741.png";